<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <CIcon name="cil-grid"/>お知らせ管理
            <div class="card-header-actions">
              <a
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              ></a>
            </div>
          </CCardHeader>
          <CCardBody>
            <CCol class="text-right px-0 mb-3 sm-12 mt-2">
              <CButton color="info" @click='showRecordModal({},0, "Create")'>新規作成</CButton>
            </CCol>
            <CDataTable
              :items="items"
              :fields="fields"
              striped
              hover
              bordered
            >
            <template #target="{ item }">
              <td>{{ displayTargetLabel(item.target) }}</td>
            </template>
            <template #start_on="{ item }">
              <td>{{ formatDate(item.start_on) }}</td>
            </template>
            <template #end_on="{ item }">
              <td>{{ formatDate(item.end_on) }}</td>
            </template>
              <template #operations="{item, index}">
                <td class="py-2">
                  <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                  <CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                </td>
              </template>
              <template #under-table>
                <CCol sm="12" class="text-center">
                  <paginate
                    :page-count="meta.total_pages"
                    :prev-text="'前へ'"
                    :next-text="'次へ'"
                    :click-handler="paging"
                    :container-class="'pagination'">
                  </paginate>
                </CCol>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
      size="lg"
    >
      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label pt-3">タイトル</label>
          <CInput placeholder="タイトル" v-model="record.title" :class="{ 'hasError': $v.record.title.$error }"/>
          <small v-if="$v.record.title.$error" class="errorLabel">タイトルを入力してください</small>
        </CCol>
        <CCol sm="12">
          <label class="record-label pt-3">本文</label>
          <CTextarea
            placeholder="本文"
            v-model="record.body"
            :class="{ 'hasError': $v.record.body.$error }"
            rows="5"
          />
          <small v-if="$v.record.body.$error" class="errorLabel">本文を入力してください</small>
        </CCol>
        <CCol sm="12">
          <label class="record-label pt-3">掲載対象</label>
            <CSelect
              placeholder="掲載対象を選択"
              :class="{ 'hasError': $v.record.target.$error }"
              :options="targetType"
              :value.sync="record.target"
            />
          <small v-if="$v.record.target.$error" class="errorLabel">掲載対象を選択してください</small>
        </CCol>
        <CCol sm="12">
          <label class="record-label pt-3">掲載開始日</label>
          <CInput
            type="date"
            v-model="record.start_on"
            :class="{ 'hasError': $v.record.start_on.$error }"
          />
          <small v-if="$v.record.start_on.$error" class="errorLabel">
            掲載開始日を入力してください
          </small>
        </CCol>
        <CCol sm="12">
          <label class="record-label pt-3">掲載終了日</label>
          <CInput
            type="date"
            v-model="record.end_on"
            :class="{ 'hasError': $v.record.end_on.$error }"
          />
          <small v-if="$v.record.end_on.$error" class="errorLabel">
            掲載終了日を入力してください
          </small>
        </CCol>
      </CRow>
      <template #footer>
        <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
        <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">送信</CButton>
      </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>このお知らせを削除しますか？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';
import Vue from 'vue'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

export default {
  name: 'Home',
  components: {Paginate},
  data() {
    return {
      isLoading: false,
      mode: 'Create',
      recordModal: false,
      deleteModal: false,
      itemIndex: 0,
      record: {},
      items: [],
      filter_cs: [],
      filter_vs: [],
      industryTypes: [],
      page: 1,
      word: "",
      sort_column: "id",
      sort_asc: "desc",
      select_gender: '',
      select_status: '',
      meta: {},
      industries: {},
      schoolTypes:[],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'title', label: 'タイトル' },
        { key: 'target', label: '掲載対象' },
        { key: 'start_on', label: '掲載開始日' },
        { key: 'end_on', label: '掲載終了日' },
        { key: 'operations', label: '',  _style: 'width:15%', sorter: false, filter: false }
      ],
      targetType:[
        {'value': 'all', 'label': '全て'},
        {'value': 'school', 'label': '学校'},
        {'value': 'hrbiz', 'label': '企業'},
      ]
    }
  },
  validations: {
    record: {
      title: {required},
      body: {required},
      target: {required},
      start_on: {required},
      end_on: {required}
    }
  },
  methods: {
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "お知らせを作成する" : "お知らせを編集する"
    },
    showRecordModal: function(i, index, mode = "Edit") {
      this.recordModal = true

      if (mode === "Create") {
        this.record = {
          title: '',
          body: '',
          target: '',
          start_on: '',
          end_on: ''
        };
      }

      this.record = JSON.parse(JSON.stringify(i))

      this.mode = mode
      this.itemIndex = index

      this.$nextTick(() => {
        this.$v.record.$reset()
      })
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/notices/" + this.record.id, { headers: { 'Authorization': 'Bearer ' + this.idToken }})
        .then(() => {
          this.deleteModal = false
          this.items.splice(this.itemIndex, 1)
        }).catch(error => {
          console.log(error)
        })
    },
    updateItem: function(mode="Create", index=0) {
      this.$v.record.$touch();
      if (this.$v.record.$invalid) {
        return;
      }

      if(mode == "Create") {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/notices", { "notice": this.record }, {headers: { 'Authorization': 'Bearer ' + this.idToken }})
          .then(response => {
            this.recordModal = false
            this.items.unshift(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/notices/" + this.record.id, { "notice": this.record }, { headers: { 'Authorization': 'Bearer ' + this.idToken }})
          .then(() => {
            this.recordModal = false
            this.$set(this.items, index, JSON.parse(JSON.stringify(this.record)))
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/notices?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.items = response.data.notices
          this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    displayTargetLabel(value) {
      const target = this.targetType.find(t => t.value === value);
      return target ? target.label : value;
    },
    formatDate: function(value) {
        return moment(value).format("YYYY年MM月DD日")
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/notices", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.items = response.data.notices
        this.meta = response.data.meta
      }).catch(error => {
        this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools_all", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        response.data.forEach(row =>{
          this.schoolTypes.push(
            {'value': row.id, 'label': row.title}
          )
        })
        this.school = response.data
      }).catch(error => {
        this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
